import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import {
    FormGroup,
    FormControlLabel,
    Checkbox, Typography, Tooltip
} from "@mui/material";
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CustomAutocomplete from '../../../Components/AutoComplete/AutoComplete'
import CrudButtons from '../../../GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../GlobalFunction/useModulePermissions';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const CustomTextField = styled(TextField)(({ theme }) => ({
    '& .MuiFilledInput-root': {
        backgroundColor: 'transparent',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
    },
    '& .Mui-focused': {
        borderColor: '#673ab7',
    },
    '& .MuiFilledInput-root.Mui-focused': {
        border: '1px solid #673ab7',
    },
}));

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'EmpTypeName', label: 'Type', minWidth: 170 },
    { id: 'EmpName', label: 'Employee', minWidth: 100 },
    { id: 'Mobile', label: 'Mobile', minWidth: 100 },
    { id: 'Email', label: 'Email', minWidth: 100 },
    { id: 'PanNo', label: 'Pan No', minWidth: 100 },
    { id: 'PinId', label: 'Pincode', minWidth: 100 }
];

const EmployeeMaster = () => {
    const [formData, setFormData] = useState({
        EmpTypeName: '',
        EmpName: '',
        Mobile: '',
        Email: '',
        PanNo: '',
        PinCode: '',
        PermanentAddr: '',
        CurrentAddr: '',
        Photo: ''
    });

    // const permissions = useModulePermissions("Employee Master");

    const [error, setError] = useState({
        empTypeName: false,
        empName: false
    });

    const navigate = useNavigate();

    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [types, setTypes] = useState([]);
    const location = useLocation();
    const [currentEmployeeId, setCurrentEmployeeId] = useState(null);
    const [mode, setMode] = useState('view');
    const [lastInsertedEmployeeId, setLastInsertedEmployeeId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [Status, setStatus] = useState("1");
    const UserId = sessionStorage.getItem('UserId')
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });

    const empTypeNameRef = useRef(null);
    const empNameRef = useRef(null);
    const mobileRef = useRef(null);
    const emailRef = useRef(null);
    const panNoRef = useRef(null);
    const pinCodeRef = useRef(null);
    const permanentAddrRef = useRef(null);
    const currentAddrRef = useRef(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();

            const readFileAsBase64 = (file) => {
                return new Promise((resolve, reject) => {
                    reader.onloadend = () => {
                        resolve(reader.result);
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                });
            };

            readFileAsBase64(file)
                .then(base64String => {
                    setFormData(prevData => ({
                        ...prevData,
                        photo: base64String
                    }));
                })
                .catch(err => {
                    console.error('Error reading file:', err);
                    toast.error('Error reading file. Please try again.');
                });
        }
    };

    useEffect(() => {
        if (location.state && location.state.EmpId) {
            setCurrentEmployeeId(location.state.EmpId);
            fetchEmpData(location.state.EmpId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    const fetchEmpData = async (id, flag) => {
        try {
            const response = await axios.post(`MstEmp/RetriveMstEmp`, {
                EmpId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const empData = response.data.Data[0];
                setFormData({
                    EmpTypeName: empData.EmpTypeId.toString(),
                    EmpName: empData.EmpName,
                    Mobile: empData.Mobile,
                    Email: empData.Email,
                    PanNo: empData.PanNo,
                    PinCode: empData.PinId.toString(),
                    PermanentAddr: empData.PermanentAddr,
                    CurrentAddr: empData.CurrentAddr,
                    Photo: empData.Photo
                });
                setStatus(empData.Status.toString() || "0");
                setIsFormDisabled(true);
                setCurrentEmployeeId(empData.EmpId);
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.error('Failed to fetch employee data');
            }
        } catch (error) {
            console.error('Error fetching employee data:', error);
            toast.error('Error fetching employee data. Please try again.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            const params = {
                start: 1,
                PageSize: 1,
                SearchText: ""
            };

            try {
                const res = await axios.post('MstEmp/getAllMstEmpDashBoard', { params });

                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                } else {
                    console.error('No data found in response');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        getRow();
    }, []);

    useEffect(() => {
        const fetchEmpTypes = async () => {
            try {
                const response = await axios.get(
                    `MstEmpType/getMstEmpTypedrp`
                );
                if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                    setTypes(response.data.Data);
                } else {
                    toast.error('Failed to fetch empTypes');
                }
            } catch (error) {
                console.error('Error fetching empTypes:', error);
                toast.error('Error fetching empTypes. Please try again.');
            }
        };

        fetchEmpTypes();
    }, []);

    const handlePrevious = async () => {
        if (currentEmployeeId && currentEmployeeId > 1) {
            await fetchEmpData(currentEmployeeId, "P");
        }
    };

    const handleNext = async () => {
        if (currentEmployeeId) {
            await fetchEmpData(currentEmployeeId, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (name === 'Employee') {
            setFormData(prevState => ({
                ...prevState,
                state: ''
            }));
        }

        if (name === 'Employee' && value !== '') {
            setTimeout(() => {
                currentAddrRef.current.focus();
            }, 100000);
        }
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === empTypeNameRef.current) {
                empNameRef.current.focus();
            } else if (event.target === empNameRef.current) {
                mobileRef.current.focus();
            } else if (event.target === mobileRef.current) {
                emailRef.current.focus();
            } else if (event.target === emailRef.current) {
                panNoRef.current.focus();
            } else if (event.target === panNoRef.current) {
                pinCodeRef.current.focus();
            } else if (event.target === pinCodeRef.current) {
                permanentAddrRef.current.focus();
            } else {
                currentAddrRef.current.focus();
            }
        }
    };

    const handleSave = async () => {

        let hasError = false;

        if (!formData.EmpTypeName) {
            toast.error('EmployeeType Name is required');
            setError(prev => ({ ...prev, empTypeName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, empTypeName: false }));
        }

        if (!formData.EmpName) {
            toast.error('Employee Name is required');
            setError(prev => ({ ...prev, empName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, empName: false }));
        }

        if (hasError) {
            return;
        }


        try {
            const payload = {
                EmpTypeId: parseInt(formData.EmpTypeName),
                EmpName: formData.EmpName,
                Mobile: formData.Mobile,
                Email: formData.Email,
                PanNo: formData.PanNo,
                PinId: parseInt(formData.PinCode),
                PermanentAddr: formData.PermanentAddr,
                CurrentAddr: formData.CurrentAddr,
                Photo: formData.Photo,
                Status: Status
            };

            let response;
            if (mode === 'edit') {
                payload.EmpId = currentEmployeeId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axios.patch(`MstEmp/UpdateMstEmp`, payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axios.post(`MstEmp/InsertMstEmp`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedEmployeeId(response.data.Data)
                    await fetchEmpData(response.data.Data);
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentEmployeeId(response.data.Data);
                } else {
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            console.error('Error saving/updating employee:', error);
            toast.error('Error saving/updating employee. Please try again.');
        }
    };

    const handleEdit = () => {
        setMode('edit');
        setIsFormDisabled(false);
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            EmpTypeName: '',
            EmpName: '',
            Mobile: '',
            Email: '',
            PanNo: '',
            PinCode: '',
            PermanentAddr: '',
            CurrentAddr: '',
            Photo: ''
        });
        setCurrentEmployeeId(null);

        setTimeout(() => {
            empTypeNameRef.current.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            await fetchEmpData(1, "L");
            setMode('view');
            setStatus('1');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const resetForm = () => {
        setFormData({
            EmpTypeName: '',
            EmpName: '',
            Mobile: '',
            Email: '',
            PanNo: '',
            PinCode: '',
            PermanentAddr: '',
            CurrentAddr: '',
            Photo: ''
        });
        setCurrentEmployeeId(null);
        setMode('view');
    };

    const handleExit = () => {
        navigate('/employeetable')
    }

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        setOpenConfirmDialog(false);
        try {
            await fetchEmpData(currentEmployeeId, "D");
            await fetchEmpData(currentEmployeeId, "N");
            setMode('view');
            setStatus('1');
            setIsFormDisabled(true);
        } catch (error) {
            console.error('Error deleting employee:', error);
            toast.error('Error occurred while deleting. Please try again.');
        }
    };


    return (
        <>
            <Box className="form-container" sx={{ height: { xs: '1025px', sm: '550px' } }}>

                <ToastContainer />
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', marginTop: '20px', flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                              <Tooltip title="Go to Privious" arrow>
                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentEmployeeId || currentEmployeeId === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>
                            </Tooltip>
                            <Tooltip title="Go to Next" arrow>
                            <Button
                                variant="contained"
                                size="small"
                                // sx={{ margin: '0px 10px' }}
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentEmployeeId}
                            >
                                <NavigateNextIcon />
                            </Button>
                            </Tooltip>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            Employee Master
                        </Typography>

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName="Employee Master"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleConfirmDelete}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item lg={8} md={8} xs={12}>
                        <Box display="flex" flexDirection="column" gap={2}>
                            <Grid item lg={12} md={12} xs={12}>
                                <Box display="flex" flexDirection="column" gap={2}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6} className='form_field'>

                                            <CustomAutocomplete
                                                options={types}
                                                id="EmpTypeName-autocomplete"
                                                name='EmpTypeName'
                                                label={
                                                    <span>
                                                        Select EmpTypeName <span style={{ color: 'red' }}>*</span>
                                                    </span>
                                                }
                                                value={types.find(EmpTypeName => EmpTypeName.Id == formData.EmpTypeName) || null}
                                                onChange={handleInputChange}
                                                disabled={isFormDisabled}
                                                error={error.empTypeName}
                                                helperText={error.empTypeName ? '' : ''}
                                                ref={empTypeNameRef}
                                                onKeyDown={handleKeyPress}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <TextField
                                                id="EmpName"
                                                name="EmpName"
                                                label={
                                                    <span>
                                                        EmpName <span style={{ color: 'red' }}>*</span>
                                                    </span>
                                                }
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.EmpName}
                                                onChange={handleInputChange}
                                                disabled={isFormDisabled}
                                                error={error.empTypeName}
                                                inputRef={empNameRef}
                                                onKeyDown={handleKeyPress}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>

                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6} lg={6}>
                                    <TextField
                                        id="Mobile"
                                        name="Mobile"
                                        label="Mobile"
                                        variant="filled"
                                        fullWidth
                                        className="custom-textfield"
                                        value={formData.Mobile}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                        inputRef={mobileRef}
                                        onKeyDown={handleKeyPress}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <TextField
                                        id="Email"
                                        name="Email"
                                        label="Email"
                                        variant="filled"
                                        fullWidth
                                        className="custom-textfield"
                                        value={formData.Email}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                        inputRef={emailRef}
                                        onKeyDown={handleKeyPress}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <TextField
                                        id="PanNo"
                                        name="PanNo"
                                        label="Pan No"
                                        variant="filled"
                                        fullWidth
                                        className="custom-textfield"
                                        value={formData.PanNo}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                        inputRef={panNoRef}
                                        onKeyDown={handleKeyPress}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={3}>
                                    <TextField
                                        id="PinCode"
                                        name="PinCode"
                                        label="Pincode"
                                        variant="filled"
                                        fullWidth
                                        className="custom-textfield"
                                        value={formData.PinCode}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                        inputRef={pinCodeRef}
                                        onKeyDown={handleKeyPress}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={3}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disabled={isFormDisabled}
                                                    checked={Status === "1"}
                                                    onChange={handleChangeStatus}
                                                />
                                            }
                                            label="Status"
                                        />
                                    </FormGroup>
                                </Grid>
                            </Grid>

                        </Box>
                    </Grid>
                    <Grid item lg={4} md={4} xs={12} display="flex" alignItems="center" justifyContent="center">
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            gap={2}
                            border="1px solid #ccc"
                            borderRadius={1}
                            width={130}
                            height={150}
                            overflow="hidden"
                            position="relative"
                        >
                            {formData.Photo ? (
                                <img
                                    src={formData.Photo}
                                    alt="Uploaded Preview"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                            ) : (
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    style={{ textAlign: 'center' }}
                                >
                                    Photo
                                </Typography>
                            )}
                        </Box>
                        <input
                            accept="image/*"
                            style={{ display: 'none' }}
                            disabled={isFormDisabled}
                            id="upload-photo"
                            type="file"
                            onChange={handleFileChange}
                        />
                        <label htmlFor="upload-photo">
                            <Button
                                component="span"
                                style={{ marginTop: '5px' }}
                            >
                                Upload Image
                            </Button>
                        </label>
                    </Grid>
                    <Grid item lg={12} md={12} xs={12}>

                        <Box display="flex" flexDirection="column" gap={2}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6} lg={6}>
                                    <TextField
                                        fullWidth
                                        label="Permanent Address"
                                        name="PermanentAddr"
                                        value={formData.PermanentAddr || ''}
                                        onChange={handleInputChange}
                                        multiline
                                        rows={2}
                                        variant="filled"
                                        disabled={isFormDisabled}
                                        inputRef={permanentAddrRef}
                                        onKeyDown={handleKeyPress}
                                        className="custom-textfield"
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                height: '115px',
                                            },
                                            '& .MuiInputBase-input': {
                                                resize: 'vertical',
                                            },
                                            '& .MuiFilledInput-root': {
                                                '&:hover': {
                                                    backgroundColor: 'transparent',
                                                },
                                                '&.Mui-focused': {
                                                    backgroundColor: 'transparent',
                                                },
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <TextField
                                        fullWidth
                                        label="Current Address"
                                        name="CurrentAddr"
                                        value={formData.CurrentAddr || ''}
                                        onChange={handleInputChange}
                                        multiline
                                        rows={2}
                                        variant="filled"
                                        disabled={isFormDisabled}
                                        inputRef={currentAddrRef}
                                        onKeyDown={handleKeyPress}
                                        className="custom-textfield"
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                height: '115px',
                                            },
                                            '& .MuiInputBase-input': {
                                                resize: 'vertical',
                                            },
                                            '& .MuiFilledInput-root': {
                                                '&:hover': {
                                                    backgroundColor: 'transparent',
                                                },
                                                '&.Mui-focused': {
                                                    backgroundColor: 'transparent',
                                                },
                                            },
                                        }}
                                    />
                                </Grid>

                            </Grid>
                        </Box>

                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>

                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>

                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 && <ReportTable
                    columns={columns}
                    rows={rows}
                    title="Employee Master"
                    contentRef={contentRef}
                    customStyles={{ backgroundColor: '#f5f5f5' }}
                />
                }
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default EmployeeMaster